import React, { createContext, useContext, useState, ReactNode } from 'react';

interface HeaderCtx {
  userName: string | null;
  userInitials: string | null;
  setHeaderUser: (name: string | null, initials: string | null) => void;
}

const HeaderContext = createContext<HeaderCtx>({
  userName: null,
  userInitials: null,
  setHeaderUser: () => {},
});

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [userName, setUserName] = useState<string | null>(null);
  const [userInitials, setUserInitials] = useState<string | null>(null);

  const setHeaderUser = (name: string | null, initials: string | null) => {
    setUserName(name);
    setUserInitials(initials);
  };

  return (
    <HeaderContext.Provider value={{ userName, userInitials, setHeaderUser }}>
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeaderUser() {
  return useContext(HeaderContext);
}
